import React, {Component} from 'react';
import '../css/App.css';
import {connect} from 'react-redux';
import {
    BrowserRouter,
} from "react-router-dom";
import '../styles/reduction.scss';
import AuthRoute from '../Routes/AuthRoute';
import MainRoute from '../Routes/MainRoute';
import axios from "axios";
import {Spinner} from "react-bootstrap";
import {Alert} from "reactstrap";
import componentQueries from 'react-component-queries';
// import CryptoJS from 'crypto-js';

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            error: false,
            messageError: ''
        }
    }

    async componentDidMount() {
        // console.log(window.location.href);
        if ( this.props.errorConfigSystem ) {
            await this.loadConfigSystem();
        }
        await this.loadMenuCustomer();
        await this.loadHead();
    }

    componentDidUpdate() {
        this.loadHead();
    }      

    loadConfigSystem = () => {
        this.setState({
            isLoading: true,
        })
        // let config = {
        //     username: process.env.REACT_APP_CLIENT_ID,
        //     password: process.env.REACT_APP_CLIENT_PASSWD,
        //     token: process.env.REACT_APP_KEY,
        // };
        // config = JSON.stringify(config);
        // const ciphertext = CryptoJS.AES.encrypt(config, process.env.REACT_APP_HEADER_SECRET_KEY).toString();
        // console.log(ciphertext);

        // let dataAuth = {
        //     username: process.env.REACT_APP_CLIENT_ID,
        //     password: process.env.REACT_APP_CLIENT_PASSWD,
        //     token: process.env.REACT_APP_KEY,
        //     // AuthTokenConfig: ciphertext,
        // };

        axios.get( process.env.REACT_APP_API_URL + '/api/getConfigSystem',
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify({
                        username: process.env.REACT_APP_CLIENT_ID,
                        password: process.env.REACT_APP_CLIENT_PASSWD,
                        token: process.env.REACT_APP_KEY,
                    })
                }
            }
        )
            .then( async (ref) => {
                // console.log(ref.data);
                if (ref.data.error === 0) {
                    let favicon = document.querySelector('link[rel="icon"]');
                    favicon.href = ref.data.content.website_favicon;

                    let favicon2 = document.querySelector('link[rel="apple-touch-icon"]');
                    favicon2.href = ref.data.content.website_favicon;

                    document.title = ref.data.content.website_title;
                    document.querySelector('meta[name="description"]').setAttribute('content', ref.data.content.website_company);

                    let item = {
                        vps: ref.data.menu.vps,
                        vps_gpu: ref.data.menu.vps_gpu,
                        nat_vps: ref.data.menu.nat_vps,
                        cloudServer: ref.data.menu.cloudServer,
                        hosting: ref.data.menu.hosting,
                        vps_us: ref.data.menu.vps_us,
                        proxy: ref.data.menu.proxy,
                    }
                    
                    await this.props.updateSystem(ref.data.content);
                    await this.props.updateMenuProduct(item);
                    await this.props.updateMenu(ref.data.menu.menuProduct);

                    if ( !ref.data.licence.error ) {
                        let license = {
                            autoBanking: ref.data.licence.auto_banking,
                            template: ref.data.licence.template,
                            live_chat: ref.data.licence.live_chat,
                            telegram: ref.data.licence.telegram,
                            mail_marketing: ref.data.licence.mail_marketing,
                        }
                        await this.props.updateLicense(license);
                    }

                    // await this.props.updateTextLiveChat( { configLiveChat: ref.data.configLiveChat } );
                    if ( ref.data.licence.live_chat ) {
                        document.getElementById("live-chat").innerHTML = ref.data.configLiveChat;
                    }

                    await this.setState({
                        error: false,
                        messageError: '',
                        isLoading: false,
                        btnDisable: false,
                    })
                } else {
                    this.setState({
                        error: true,
                        btnDisable: true,
                        messageError: ref.data.message,
                        isLoading: false,
                    })
                }
                // console.log(this.state.perPage);
            })
            .catch( () => {
                // console.log(error);
                this.setState({
                    isLoading: false,
                    error: true,
                    btnDisable: true,
                    messageError: 'Lấy dữ liệu thất bại',
                })
            })
    }  

    loadHead = () => {
        let favicon = document.querySelector('link[rel="icon"]');
        favicon.href = this.props.config.website_favicon;

        let favicon2 = document.querySelector('link[rel="apple-touch-icon"]');
        favicon2.href = this.props.config.website_favicon;

        document.title = this.props.config.website_title;
        document.querySelector('meta[name="description"]').setAttribute('content', this.props.config.website_company);
    }

    loadMenuCustomer = () => {
        if ( this.props.menu === 'user' ) {
            // let dataAuth = {
            //     username: process.env.REACT_APP_CLIENT_ID,
            //     password: process.env.REACT_APP_CLIENT_PASSWD,
            //     token: process.env.REACT_APP_KEY,
            // };

            axios.get( process.env.REACT_APP_API_URL + '/api/home/getMenuCustomer',
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization' : this.props.token,
                        'dataAgency' : JSON.stringify({
                            username: process.env.REACT_APP_CLIENT_ID,
                            password: process.env.REACT_APP_CLIENT_PASSWD,
                            token: process.env.REACT_APP_KEY,
                        })
                    }
                }
            )
                .then( (ref) => {
                    // console.log(ref.data);
                    if ( ref.data.error === 0 ) {
                        this.props.updateMenuCustomer( ref.data.menu_customer );
                    } else {
                        if ( ref.data.error > 9000 ) {
                            this.props.logOut();
                        }
                    }
                    // console.log(this.state.perPage);
                })
                .catch( (error) => {
                    console.log(error);
                })
        }
    }

    changeRedirectLogin = () => {
        this.props.changeRedirectLogin();
    }

    render() {
        return (
            <BrowserRouter>
                {
                    this.state.isLoading ? (
                        <div className="load-system-config">
                            <div className="load-page-config">
                                <Spinner animation="border" variant="primary"/>
                            </div>
                        </div>
                    ) : (
                        <>
                            {
                                this.state.error ? (

                                    <Alert color="danger">
                                        <div className='text-center'>
                                            { this.state.messageError }
                                        </div>
                                    </Alert>
                                ) : (
                                    <>
                                        {
                                            // && this.props.is2Fa
                                            this.props.isSinged && this.props.isupdateInfo ? (
                                                <>
                                                    <MainRoute breakpoint={this.props.breakpoint} role={this.props.user.role} menu={this.props.menu}
                                                               system={this.props.system}/>
                                                </>
                                            ) : (
                                                <>
                                                    <AuthRoute/>
                                                </>
                                            )
                                        }
                                    </>
                                )
                            }
                        </>
                    )
                }
            </BrowserRouter>
        );
    };
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isSinged: state.login.isSinged,
        is2Fa: state.login.is2Fa,
        user: state.user.user,
        menu: state.user.menu,
        redirectLogin: state.login.redirectLogin,
        config: state.configSystem.config,
        errorMenuCustomer: state.system.errorMenuCustomer,
        vps: state.system.vps,
        cloudServer: state.system.cloudServer,
        hosting: state.system.hosting,
        menuProduct: state.system.menuProduct,
        isMenuCustomer: state.system.isMenuCustomer,
        menuCustomer: state.system.menuCustomer,
        errorConfigSystem: state.configSystem.errorConfigSystem,
        isupdateInfo: state.login.isupdateInfo,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch({type: 'logOut'})
        },
        offLoadUser: () => {
            dispatch({type: 'offLoadUser'})
        },
        changeRedirectLogin: () => {
            dispatch({type: 'changeRedirectLogin'})
        },
        updateMenu: (item) => {
            dispatch(({type: 'updateMenu', item}))
        },
        updateMenuProduct: (item) => {
            dispatch(({type: 'updateMenuProduct', item}))
        },
        updateSystem: (item) => {
            dispatch(({type: 'updateSystem', item}))
        },
        updateLicense: (item) => {
            dispatch(({type: 'updateLicense', item}))
        },
        updateTextLiveChat: (item) => {
            dispatch(({type: 'updateTextLiveChat', item}))
        },
        updateMenuCustomer: (item) => {
            dispatch(({ type : 'updateMenuCustomer', item }))
        }
    }
}

const query = ({ width }) => {
  if (width < 575) {
    return { breakpoint: 'xs' };
  }

  if (576 < width && width < 767) {
    return { breakpoint: 'sm' };
  }

  if (768 < width && width < 991) {
    return { breakpoint: 'md' };
  }

  if (992 < width && width < 1199) {
    return { breakpoint: 'lg' };
  }

  if (width > 1200) {
    return { breakpoint: 'xl' };
  }

  return { breakpoint: 'xs' };
};


export default connect(mapStateToProps, mapDispatchToProps)(componentQueries(query)(App));
